<script setup lang="ts">
import { spinProps } from 'naive-ui';

const props = defineProps(spinProps);
</script>

<template>
  <!-- Themed n-spin — the loading veil over a region that already has its
       shape. Wrap the content in the default slot so the veil covers it;
       with no content it renders as a standalone spinner.

       Prefer this only for a first load. A background refresh (websocket or
       poll) must NOT set `show`, or the view flashes on every event. -->
  <n-spin v-bind="props">
    <!-- Forward the default slot only when given: n-spin switches to its
         absolutely-positioned veil whenever one exists, even empty, which
         leaves a standalone spinner with no width of its own. -->
    <template v-if="$slots.default" #default><slot /></template>
    <template v-if="$slots.description" #description><slot name="description" /></template>
    <template v-if="$slots.icon" #icon><slot name="icon" /></template>
  </n-spin>
</template>
